var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#737373;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,13c0.3,0,0.5-0.1,0.7-0.3C7.9,12.5,8,12.3,8,12s-0.1-0.5-0.3-0.7C7.5,11.1,7.3,11,7,11s-0.5,0.1-0.7,0.3 C6.1,11.5,6,11.7,6,12s0.1,0.5,0.3,0.7C6.5,12.9,6.7,13,7,13z M12,13c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7 s-0.1-0.5-0.3-0.7C12.5,11.1,12.3,11,12,11s-0.5,0.1-0.7,0.3C11.1,11.5,11,11.7,11,12s0.1,0.5,0.3,0.7C11.5,12.9,11.7,13,12,13z  M17,13c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7C17.5,11.1,17.3,11,17,11s-0.5,0.1-0.7,0.3 C16.1,11.5,16,11.7,16,12s0.1,0.5,0.3,0.7C16.5,12.9,16.7,13,17,13z M12,21c-1.2,0-2.4-0.2-3.5-0.7c-1.1-0.5-2-1.1-2.8-1.9 c-0.8-0.8-1.5-1.8-1.9-2.8C3.2,14.4,3,13.2,3,12s0.2-2.4,0.7-3.5c0.5-1.1,1.1-2,1.9-2.9c0.8-0.8,1.8-1.4,2.8-1.9 C9.6,3.2,10.8,3,12,3s2.4,0.2,3.5,0.7c1.1,0.5,2,1.1,2.9,1.9c0.8,0.8,1.4,1.8,1.9,2.9C20.8,9.6,21,10.8,21,12s-0.2,2.4-0.7,3.5 c-0.5,1.1-1.1,2-1.9,2.8c-0.8,0.8-1.8,1.5-2.9,1.9C14.4,20.8,13.2,21,12,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingCircleIcon);
export default __webpack_public_path__ + "static/media/pending-circle-icon.9f19a8b76c2e0d797f8f77eef2d22afa.svg";
export { ForwardRef as ReactComponent };